import {useLocation, useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import {getJobById} from "../../utilities/cvAPI";
import Enums from "../General/Enums";
import {IconButton} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import JobSummaryCard from "./JobSummaryCard";
import MoreJobsCard from "./MoreJobsCard";
import {getJobsExternal} from "../../utilities/HrAPI";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import {getJobTypeByValue} from "./JobCard";
import FormControl from "@mui/material/FormControl";
import EditorState from "draft-js/lib/EditorState";
import { Editor } from 'react-draft-wysiwyg';
import {convertFromRaw, convertToRaw} from "draft-js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function JobDetails() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const jobHash = searchParams.get('jobHash');
    const clientId = searchParams.get('clientId');
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [job, setJob] = useState(Enums.job);
    const [jobs, setJobs] = useState([]);
    const navigate = useNavigate();

    const handleEditorChange = (newState) => {
        setEditorState(newState);
        const content = newState.getCurrentContent(); // If you want plain text, otherwise convert it to the required format
        const rawContent = convertToRaw(content)
        const contentJson = JSON.stringify(rawContent)
        setJob((prev) => ({
            ...prev,
            jobDetails: {
                ...prev.jobDetails,
                rolesResponsibilities: contentJson,
            },
        }));
    };

    useEffect(() => {
        getJobsExternal(clientId)
            .then(jobList => {
                setJobs(jobList)
            })
            .catch(e => {
                console.error("Error fetching jobs:", e)
            });
    }, [clientId])

    useEffect(() => {
        getJobById(jobHash)
            .then(job => {
                setJob(job)
                const contentBlock = (job.jobDetails.rolesResponsibilities);
                if (contentBlock) {
                    const contentState = convertFromRaw(JSON.parse(contentBlock));
                    const newEditorState = EditorState.createWithContent(contentState);
                    setEditorState(newEditorState);

                    console.log(contentState)
                }
            })
            .catch(e => {
                console.error("Error fetching job:", e)
            });
    }, [jobHash]);

    const handleBackClick = () => {
        navigate(`/JobListing?clientId=${clientId}`)
    };

    return (
        <Box data-testid={"detail-box"} style={{
            height: 'max-content',
            backgroundColor: 'white',
            elevation: 1,
            marginLeft: '5%',
            marginRight: '5%',
            marginTop: '5%'
        }}>
            <Paper style={{backgroundColor: '#ff6600', borderRadius: "20px", padding: '20px'}}>
                <Grid container direction={"row"} justifyContent={"center"} alignItems={"center"}>
                    <Grid item xs={1}>
                        <IconButton
                            data-testid={"job-detail-navigate-back"}
                            sx={{ color: '#ffffff' }}
                            onClick={handleBackClick}>
                            <ArrowBackIcon />
                        </IconButton>
                    </Grid>

                    <Grid item xs={10} sm={10} md={10} lg={10} className={"text-center"}>
                        <h1-white>{job.jobTitle}</h1-white>
                    </Grid>

                    <Grid item xs={1}>
                        <IconButton sx={{
                            width: 50,
                            height: 50,
                            color: 'black',
                            bgcolor: 'white',
                            float: 'right',
                            marginRight: 1,
                            mb: 1,
                            '&:hover': {
                                backgroundColor: 'rgba(255,255,255,0.91)', // Change to a color that contrasts well with white
                            },
                        }}><ShareIcon/></IconButton>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container direction={"row"} padding={2} spacing={2}>
                {/*Left side*/}
                <Grid item xs={8}>
                    <Grid container direction={"column"} padding={2} spacing={2}>
                        <Grid item xs={2.5}>
                            <Box>
                                <Grid container direction={"row"} spacing={2}>
                                    <Grid item xs={12}>
                                        <Paper elevation={2} style={{backgroundColor: 'white', borderRadius: "20px", padding: '20px'}}>
                                            <h2-bold>Job Description</h2-bold>
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <tbody>{job.jobDetails.description}</tbody>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>

                        <Grid item xs={3.5}>
                            <Box>
                                <Paper elevation={2} style={{backgroundColor: 'white', borderRadius: "20px", padding: '20px'}}>
                                    <h2-bold>What roles and responsibilities will you have</h2-bold>
                                </Paper>
                                {/*<tbody>{job.jobDetails.rolesResponsibilities}</tbody>*/}
                                <FormControl  sx={{
                                    width: '100%',
                                    marginTop: '16px',
                                    "& label.Mui-focused": {
                                        color: "#FF6600",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#FF6600",
                                        },
                                    },
                                }}>
                                    <Box
                                        sx={{
                                            borderRadius: '8px',
                                            '&:hover': {
                                                borderColor: '#FF6600',
                                            },
                                            "& .Mui-focused": {
                                                borderColor: "#FF6600",
                                            },
                                        }}
                                        data-testid="wysiwyg-editor"
                                    >
                                        <Editor
                                            readOnly={true}
                                            editorState={editorState}
                                            onEditorStateChange={handleEditorChange}
                                            toolbarClassName="toolbarClassName"
                                            wrapperClassName="wrapperClassName"
                                            editorClassName="editorClassName"
                                            toolbarHidden={true}
                                            toolbar={{
                                                options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link'],
                                            }}
                                        />
                                    </Box>
                                </FormControl>
                            </Box>
                        </Grid>

                        <Grid item xs={1} hidden={true}>
                            <Box>
                                <Paper elevation={2} style={{backgroundColor: 'white', borderRadius: "20px", padding: '20px'}}>
                                    <h2-bold>What type of projects will you work on?</h2-bold>
                                </Paper>
                                <tbody>{getJobTypeByValue(job.jobDetails.jobType)}</tbody>
                            </Box>
                        </Grid>

                        <Grid item xs={2.5} hidden={true}>
                            <Box>
                                <Paper elevation={2} style={{backgroundColor: 'white', borderRadius: "20px", padding: '20px'}}>
                                    <h2-bold>What experience and skills are we looking for in you?</h2-bold>
                                </Paper>
                                {job.jobDetails.skills.map((skill, index) => (
                                    <tbody>- {skill.skill} ({skill.years} years)</tbody>
                                ))}
                            </Box>
                        </Grid>

                        <Grid item xs={2.5} hidden={true}>
                            <Box>
                                <Paper elevation={2} style={{backgroundColor: 'white', borderRadius: "20px", padding: '20px'}}>
                                    <h2-bold>What other stuff do we need</h2-bold>
                                </Paper>
                                <tbody>{job.jobDetails.description}</tbody>
                            </Box>
                        </Grid>

                    </Grid>
                </Grid>

                {/*Right side*/}
                <Grid item xs={4}>
                    <Grid container direction={"column"} padding={2} spacing={2}>
                        <Grid item xs={4}>
                            <Card
                                sx={{
                                    borderRadius: 4,
                                    boxShadow: 3,
                                    marginBottom: 2,
                                    padding: 2,
                                }}
                            >
                                <CardContent>
                                    <JobSummaryCard job={job.jobDetails} applicationState={false} hashedCode={job.hashedCode} />
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item xs={8}>
                            <Card
                                sx={{
                                    borderRadius: 4,
                                    boxShadow: 3,
                                    marginBottom: 2,
                                    padding: 2,
                                }}
                            >
                                <CardContent>
                                    <h2-bold>
                                        More Jobs Like This
                                    </h2-bold>

                                    {jobs.map((job, index) => (
                                        <MoreJobsCard
                                            clientId={clientId}
                                            key={index}
                                            job={job}
                                        />
                                    ))}
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )

}